import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { USER_TYPE_SALES_OPPORTUNITY_PRIORITY } from '../../../public/types/user-type-sales-opportunity-priority.const';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { User } from '../../types/user.model';
import { AddInterestAboutAfricaModalComponent } from '../add-interest-about-africa-modal/add-interest-about-africa-modal.component';
import { AddLookingForItemsModalComponent } from '../add-looking-for-items-modal/add-looking-for-items-modal.component';
import { AddLifeGoalModalComponent } from '../add-life-goal-modal/add-life-goal-modal.component';
import { AddMissionModalComponent } from '../add-mission-modal/add-mission-modal.component';
import { AddNeedSupportWithItemsModalComponent } from '../add-need-support-with-items-modal/add-need-support-with-items-modal.component';

@Component({
  selector: 'mmb-web-app-step-hello',
  templateUrl: './step-hello.component.html',
  styleUrls: ['./step-hello.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepHelloComponent implements OnInit {
  @Input() user: User;
  lookingFor: {
    opportunities?: any[],
    people?: any[],
    service?: any[],
  } = {};
  userRequests: any[];
  userOffers: any[];

  scoringLevels = USER_TYPE_SALES_OPPORTUNITY_PRIORITY;

  constructor(private userOnboardingService: UserOnboardingService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this._getUserInterests();
    this._getUserRequests();
    this._getUserOffers();
  }

  /**
   * Create life-goal modal
   */
  addLifeGoal(lifeGoal: string) {
    const modalRef = this.modalService.open(AddLifeGoalModalComponent, { centered: true });
    modalRef.componentInstance.lifeGoal = lifeGoal;
    modalRef.componentInstance.isEditMode = !!lifeGoal;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  /**
   * Create mission modal
   */
  addMission(mission: string) {
    const modalRef = this.modalService.open(AddMissionModalComponent, { centered: true });
    modalRef.componentInstance.mission = mission;
    modalRef.componentInstance.isEditMode = !!mission;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  addInterestAboutAfrica(interest: string) {
    const modalRef = this.modalService.open(AddInterestAboutAfricaModalComponent, { centered: true });
    modalRef.componentInstance.interest = interest;
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this.user.credentials.interest_africa_general = ev;
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openNeedSupportOfferHelpModal() {
    const modalRef = this.modalService.open(AddNeedSupportWithItemsModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.userRequests = this.userRequests;
    modalRef.componentInstance.userOffers = this.userOffers;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this.userOffers = ev.userOffers;
      this.userRequests = ev.userRequests;
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  openLookingForItemsModal() {
    const modalRef = this.modalService.open(AddLookingForItemsModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.userRequests = this.userRequests;
    modalRef.componentInstance.userOffers = this.userOffers;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      modalRef.close();
      this.lookingFor = ev.itemsSelection;
      this.lookingFor.service = ev.itemsSelection.support;
      this.user.credentials.interest_opportunity_specific = ev.itemsSelection.other;
    });
    modalRef.componentInstance.closed.subscribe((ev) => {
      modalRef.close();
    });
  }

  getItemScore(value) {
    return this.scoringLevels.length - value + 1; // plus 1 as index is 1 based and not zero
  }

  private _getUserRequests() {
    this.userOnboardingService.getUserRequest().subscribe((res => {
      this.userRequests = res;
    }));
  }

  private _getUserOffers() {
    this.userOnboardingService.getUserOffer().subscribe((res => {
      this.userOffers = res;
    }));
  }

  private _getUserInterests() {
    this.userOnboardingService.getOpportunityInterest(true).subscribe((opportunities) => {
      this.lookingFor.opportunities = opportunities;
    });

    this.userOnboardingService.getPeopleInterest(true).subscribe((opportunities) => {
      this.lookingFor.people = opportunities;
    });

    this.userOnboardingService.getServiceInterest(true).subscribe((opportunities) => {
      this.lookingFor.service = opportunities;
    });
  }
}
